(() => {
  const initializeSection = (root) => {
    if (!root || root.dataset.tenLoveReviewsInitialized === 'true') return;
    root.dataset.tenLoveReviewsInitialized = 'true';

    const wall = root.querySelector('[data-ten-love-review-wall]');
    const sortButtons = root.querySelectorAll('[data-ten-love-review-sort]');
    if (wall && sortButtons.length) {
      const cards = Array.from(wall.querySelectorAll('[data-ten-love-review-card]'));
      sortButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const mode = button.dataset.tenLoveReviewSort;
          const sortedCards = [...cards].sort((a, b) => {
            if (mode === 'featured') return Number(a.dataset.featuredIndex) - Number(b.dataset.featuredIndex);
            const ratingDifference = Number(b.dataset.rating) - Number(a.dataset.rating);
            return (mode === 'lowest' ? -ratingDifference : ratingDifference) || Number(a.dataset.featuredIndex) - Number(b.dataset.featuredIndex);
          });
          sortedCards.forEach((card) => wall.appendChild(card));
          sortButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          const sort = button.closest('details');
          sort?.removeAttribute('open');
          sort?.querySelector('summary')?.focus();
        });
      });
    }

    const dialog = root.querySelector('[data-ten-love-review-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    let opener = null;
    const dialogImage = dialog.querySelector('[data-ten-love-dialog-image]');
    const dialogMedia = dialog.querySelector('[data-ten-love-dialog-media]');
    const dialogName = dialog.querySelector('[data-ten-love-dialog-name]');
    const dialogTitle = dialog.querySelector('[data-ten-love-dialog-title]');
    const dialogRating = dialog.querySelector('[data-ten-love-dialog-rating]');
    const dialogQuote = dialog.querySelector('[data-ten-love-dialog-quote]');
    const dialogProduct = dialog.querySelector('[data-ten-love-dialog-product]');

    root.querySelectorAll('[data-ten-love-review-open]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const card = link.closest('[data-ten-love-review-card]');
        const image = card?.querySelector('.ten-love-photo-review__image');
        if (!card || !image) return;
        event.preventDefault();
        opener = link;
        dialogImage.src = image.currentSrc || image.src;
        dialogImage.alt = image.alt;
        dialogImage.width = image.naturalWidth || Number(image.width) || 1200;
        dialogImage.height = image.naturalHeight || Number(image.height) || 1200;
        dialogMedia.toggleAttribute('data-review-cropped', link.hasAttribute('data-review-cropped'));
        dialogMedia.setAttribute('style', link.getAttribute('style') || '');
        dialogName.textContent = card.querySelector('[data-ten-love-review-name]')?.textContent || '';
        dialogTitle.textContent = card.querySelector('[data-ten-love-review-finish]')?.textContent || '';
        dialogRating.replaceChildren(card.querySelector('[data-ten-love-review-rating]')?.cloneNode(true) || '');
        dialogQuote.textContent = card.querySelector('[data-ten-love-review-quote]')?.textContent || '';
        const productLink = card.querySelector('[data-ten-love-review-product]');
        dialogProduct.hidden = !productLink;
        if (productLink) dialogProduct.href = productLink.href;
        dialog.showModal();
      });
    });

    dialog.querySelector('[data-ten-love-review-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => opener?.focus());
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('[data-ten-love-reviews]')) initializeSection(scope);
    scope.querySelectorAll?.('[data-ten-love-reviews]').forEach(initializeSection);
  };

  const setStickyOffset = () => {
    const header = document.querySelector('.reign-header, [data-reign-header], .shopify-section-group-header-group');
    const bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    document.documentElement.style.setProperty('--ten-love-sticky-offset', `${Math.round(bottom + 16)}px`);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAll();
      setStickyOffset();
    });
  } else {
    initializeAll();
    setStickyOffset();
  }

  let offsetFrame = null;
  const scheduleOffset = () => {
    if (offsetFrame) return;
    offsetFrame = requestAnimationFrame(() => {
      setStickyOffset();
      offsetFrame = null;
    });
  };
  window.addEventListener('resize', scheduleOffset, { passive: true });
  window.addEventListener('scroll', scheduleOffset, { passive: true });
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:select', setStickyOffset);
  document.addEventListener('shopify:block:select', (event) => {
    event.target.closest?.('[data-ten-love-review-card]')?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
  });
})();
